import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const useRejectionReasons = () => {
    const [reasons, setReasons] = useState([]);
    const user = useSelector(state => state.userController.user);

    useEffect(() => {
        const fetchReasons = async () => {
            if (!user) return;
            try {
                const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/rejection-reasons`, {
                    headers: {
                        'Authorization': `Bearer ${user?.token}`
                    }
                });
                if (!res.ok) return;
                const json = await res.json();
                setReasons(json.reasons);
            } catch (err) {
                // Non-critical — the admin can still type a reason manually
            }
        };
        fetchReasons();
    }, [user]);

    return { reasons };
};
